<template src="./FormStep4.html"></template>
<style lang="scss" src="./FormStep4.scss"></style>
<script>
import _ from 'lodash'
import moment from 'moment'

export default {
    name: 'FormStep4',

    data () {
        return {
            errors: [],
            data_ricontatto_date: null,
            values: {
                Lead: 'Adesione web sito AGSM',
                Data_Ricontatto: '',
                Ora_Ricontatto: '',
                SchedaProdotto: false,
                CondizioniGeneraliFornitura: false,
                NotaInformativa: false,
                InformativaPrivacy: false,
                TrattamentoDati1: '',
                TrattamentoDati2: '',
                TrattamentoDati3: '',
                TrattamentoDati4: '',
            },
            hours: [
                'Nessuna Preferenza',
                'Dalle 9 alle 12',
                'Dalle 12 alle 16',
                'Dalle 16 alle 18',
                'Dalle 18 alle 20'
            ],
        }
    },

    computed: {
        form () {
            return this.$store.state.form
        },

        formValues() {
            return this.$store.state.form.values
        },

        strings () {
            return this.$store.state.strings
        },

        svg () {
            return this.$store.state.svg
        },

        Data_Ricontatto() {
            if (!this.Data_Ricontatto_Date) {
                return null
            }

            const day = this.values.Data_Ricontatto_Date.getDate() < 10 ? '0' + this.values.Data_Ricontatto_Date.getDate() : this.values.Data_Ricontatto_Date.getDate()
            const month = this.values.Data_Ricontatto_Date.getMonth() + 1
            const monthString = month < 10 ? '0' + month : month
            const year = this.values.Data_Ricontatto_Date.getFullYear()

            return day + '/' + monthString + '/' + year
        },

        schedaProdottoPdfUrl() {
            return this.$store.state.form.schedaProdottoPdfUrl
        },

        cgfUrl() {
            return this.$store.state.form.cgfUrl
        },

        notaInfUrl() {
            return this.$store.state.form.notaInfUrl
        },

        token() {
            return this.$store.state.token
        }
    },

    watch: {
        data_ricontatto_date(value) {
            if (!value instanceof Date) {
                return
            }

            const day = (value.getDate() < 10) ? `0${value.getDate()}` : value.getDate()
            const month = ((value.getMonth() + 1) < 10) ? `0${value.getMonth() + 1}` : value.getMonth() + 1
            const year = value.getFullYear()

            this.values.Data_Ricontatto = `${day}/${month}/${year}`
        },

        formValues() {
            this.$updateValuesFromStore()
        },

        'values.Data_Ricontatto' (value) {
            if (value && !this.data_ricontatto_date) {
                const dateSplit = value.split('/')
                const day = parseInt(dateSplit[0])
                const month = parseInt(dateSplit[1])
                const year = parseInt(dateSplit[2])
                this.data_ricontatto_date = new Date(`${year}/${month}/${day}`)
            }
        }
    },

    mounted() {
        this.$updateValuesFromStore()
    },

    methods: {
        saveAndRedirect() {
            let objToken = JSON.parse(localStorage.getItem('agsmToken'))
            objToken.retrieveData = true
            localStorage.setItem('agsmToken', JSON.stringify(objToken))
            window.location.href = this.$store.state.saveAndRedirectUrl
        },

        submit () {
            this.validation()
            if (this.token && !this.errors.length) {
                let data = {
                    tokenId: this.token,
                    step: 4,
                    fields: _.map(this.values, (valueField, field) => ({
                        field,
                        valueField : valueField === null ? '' : valueField
                    }))
                }
                const formData = new FormData()
                formData.append('data', JSON.stringify(data))

                this.$apiCall('/StepFunnelWeb/AddDataStepFunnel', {
                    method: 'POST',
                    body: formData
                }).then(data => {
                    if (data && data.status && data.status === 200) {
                        this.$store.commit('formValues', this.values)
                        this.$store.commit('formIndex', 4)
                    } else {
                        alert("Si sono verificati degli errori")
                    }
                })
            }
        },

        validation () {
            this.errors = []

            if (!this.values.SchedaProdotto) {
                this.errors.push('SchedaProdotto')
            }
            if (!this.values.CondizioniGeneraliFornitura) {
                this.errors.push('CondizioniGeneraliFornitura')
            }
            if (!this.values.NotaInformativa) {
                this.errors.push('NotaInformativa')
            }
            if (!this.values.InformativaPrivacy) {
                this.errors.push('InformativaPrivacy')
            }
            if (!this.values.TrattamentoDati1 || this.values.TrattamentoDati1 === '0') {
                this.errors.push('TrattamentoDati1')
            }
            
            // if (!this.values.Data_Ricontatto.match(/^[0-9]+?\/[0-9]+?\/[0-9]{4}$/)) {
            //     this.errors.push('Data_Ricontatto')
            // } else {
            //     let referenceDate = moment().add(2, 'days')
            //     let lastDay = moment().add(12, 'days')
            //     let userDate = moment(this.data_ricontatto_date)
            //     referenceDate.millisecond(0)
            //     lastDay.millisecond(0)
            //     referenceDate.second(0)
            //     lastDay.second(0)
            //     referenceDate.minute(0)
            //     lastDay.minute(0)
            //     referenceDate.hour(0)
            //     lastDay.hour(0)

            //     while(['Saturday', 'Sunday'].includes(referenceDate.format('dddd'))) {
            //         referenceDate = referenceDate.add(1, 'days')
            //     }

            //     // not week end
            //     if(['Saturday', 'Sunday'].includes(userDate.format('dddd'))) {
            //         this.errors.push('Data_Ricontatto')
            //     }

            //     // minimun 2/4 days after
            //     if (userDate.isBefore(referenceDate)) {
            //         this.errors.push('Data_Ricontatto')
            //     }

            //     // after 12 days after
            //     if (userDate.isAfter(lastDay)) {
            //         this.errors.push('Data_Ricontatto')
            //     }
            // }

            // if (!this.values.Ora_Ricontatto) {
            //     this.errors.push('Ora_Ricontatto')
            // }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/FormStep4/FormStep4.vue